import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Auth from '../views/Auth.vue'
import SoftwareHouses from '../views/SoftwareHouses.vue'
import SoftwareHousesEdit from '../views/SoftwareHousesEdit.vue'
import Estabelecimentos from '../views/Estabelecimentos.vue'
import EstabelecimentosEdit from '../views/EstabelecimentosEdit.vue'
import Volumetria from '../views/Volumetria.vue'
import Users from '../views/Users.vue'
import Profile from '../views/Profile.vue'
import Dashboard from '../views/Dashboard.vue'
import NotFound from '../views/NotFound.vue'
import Comissoes from '@/views/Comissoes.vue'
import Aprovacoes from '@/views/Aprovacoes.vue'
import ComissaoEdit from '@/views/ComissaoEdit.vue'
// import PlanosComerciais from '../views/PlanosComerciais.vue'
// import PlanosDisponiveis from '../views/PlanosDisponiveis.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Auth',
    component: Auth
  },
  {
    path: '/software-houses',
    name: 'SoftwareHouses',
    component: SoftwareHouses,
    meta: { requiresAuth: true }
  },
  {
    path: '/software-houses/:cnpj/edit',
    name: 'SoftwareHousesEdit',
    component: SoftwareHousesEdit,
    meta: { requiresAuth: true }
  },
  {
    path: '/estabelecimentos',
    name: 'Estabelecimentos',
    component: Estabelecimentos,
    meta: { requiresAuth: true }
  },
  {
    path: '/estabelecimentos/:softwareHouseCnpj/:cnpj/edit',
    name: 'EstabelecimentosEdit',
    component: EstabelecimentosEdit,
    meta: { requiresAuth: true }
  },
  {
    path: '/volumetria',
    name: 'Volumetria',
    component: Volumetria,
    meta: { requiresAuth: true }
  },
  {
    path: '/comissoes',
    name: 'Comissões',
    component: Comissoes,
    meta: { requiresAuth: true }
  },
  {
    path: '/comissoes/:softwareHouseCnpj/:protocol',
    name: 'ComissaoEdit',
    component: ComissaoEdit,
    meta: { requiresAuth: true }
  },
  {
    path: '/aprovacoes',
    name: 'Aprovações',
    component: Aprovacoes,
    meta: { requiresAuth: true }
  },
  {
    path: '/aprovacoes/:softwareHouseCnpj/:protocol',
    name: 'AprovacaoEdit',
    component: ComissaoEdit,
    meta: { requiresAuth: true }
  },
  {
    path: '/usuarios',
    name: 'Users',
    component: Users,
    meta: { requiresAuth: true }
  },
  {
    path: '/dados',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/painel',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  // {
  //   path: '/planos',
  //   name: 'PlanosComerciais',
  //   component: PlanosComerciais
  // },
  // {
  //   path: '/planos-disponiveis',
  //   name: 'PlanosDisponiveis',
  //   component: PlanosDisponiveis
  // },
  {
    path: '/not-found',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Proteção de rotas
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  if (to.matched.some((item) => item.meta.requiresAuth) && !token) {
    next('/')
  } else {
    next()
  }
})

export default router
